var _desc, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSouthpole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.69 0 0 1.69 249.77 248.96)",
    id: "-C3dMiXUsbeIPdWIz8nUt"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(72,177,58)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,80,145)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-147.27, -140.64)",
    d: "M 147.26607 0 C 228.55694 0 294.53214 65.9752 294.53214 147.26607 C 294.53214 206.76511000000002 259.18803 258.05927 208.36376 281.28459 C 207.77422 277.04938 205.27777 259.02882 201.8434 233.02580999999998 C 197.89751 203.14982999999998 188.72566 182.44061999999997 180.31217 164.63385999999997 C 171.89868 146.82709999999997 160.65655 141.52223999999998 159.52915000000002 137.01265999999998 C 158.40175000000002 132.50307999999998 166.21972000000002 118.97432999999998 173.54779000000002 111.64625999999998 C 180.87586000000002 104.31818999999999 191.25400000000002 101.87380999999999 205.97887000000003 99.05531999999998 C 220.70374000000004 96.23682999999998 233.29976000000002 97.55381999999997 233.29976000000002 97.55381999999997 C 233.29976000000002 97.55381999999997 240.30908000000002 97.16794999999998 237.80934000000002 94.17162999999998 C 235.30960000000002 91.17530999999998 232.73606 90.78943999999998 220.8984 87.97094999999997 C 209.06074 85.15245999999998 194.40460000000002 82.89766999999998 180.31215 81.77026999999997 C 166.2197 80.64287999999996 153.81835 73.87849999999997 148.18137000000002 71.62370999999997 C 142.54440000000002 69.36890999999997 130.70674000000002 67.11411999999997 125.63346000000001 67.67781999999997 C 120.56018000000002 68.24151999999997 116.61429000000001 69.36890999999997 106.46773000000002 75.56958999999996 C 96.32117000000002 81.77026999999997 90.68419000000002 93.60792999999997 88.42940000000002 100.37229999999997 C 86.17461000000002 107.13667999999997 85.04721000000002 118.25793999999996 82.22872000000001 121.64012999999997 C 79.41023000000001 125.02231999999997 64.79099000000001 143.85083999999998 54.644430000000014 168.65354999999997 C 50.602710000000016 178.53330999999997 46.49704000000001 191.95228999999998 43.742390000000015 205.96872999999997 C 40.303120000000014 223.46869999999996 38.03362000000001 240.02753999999996 37.349950000000014 245.24416999999997 C 14.122340000000015 219.20791999999997 1.4210854715202004e-14 184.87619999999998 1.4210854715202004e-14 147.26606999999996 C 1.4210854715202004e-14 65.97519999999996 65.97520000000002 -5.684341886080802e-14 147.26607 -5.684341886080802e-14 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 110.48 157.84)",
    id: "PIzXBThgvmBj0TJlw5mCW"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-110.48, -157.84)",
    d: "M 110.20193122886133 157.83540022547913 Q 110.20293122886133 157.83540022547913 110.48478015783539 157.83540022547913 L 110.76762908680945 157.83540022547913",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 137.82 226.04)",
    id: "5KJu9W-ybuJuLVfgubtE1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-137.82, -226.04)",
    d: "M 137.82312626832018 226.04284103720406 L 137.8251262683202 226.04284103720406",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 226.32 149.94)",
    id: "pLntdY2oomxOtJKIavqsh"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-226.32, -149.94)",
    d: "M 226.32368996617808 149.94363021420517 L 226.3256899661781 149.94363021420517",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 255.64 114.43)",
    id: "fgnMjCujLNSrBVofW7WHZ"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-255.64, -114.43)",
    d: "M 255.63597857948136 114.43066516347238 L 255.63797857948137 114.43066516347238",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthpole);
export default __webpack_public_path__ + "static/media/southpole.3741e24a48cd3c579a9e2f11f30f30a3.svg";
export { ForwardRef as ReactComponent };